import { render, staticRenderFns } from "./StackingNotification.vue?vue&type=template&id=610e8b36&scoped=true&"
import script from "./StackingNotification.vue?vue&type=script&lang=ts&"
export * from "./StackingNotification.vue?vue&type=script&lang=ts&"
import style0 from "./StackingNotification.vue?vue&type=style&index=0&id=610e8b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e8b36",
  null
  
)

export default component.exports